<template>
    <el-dialog
        :title="po.quoteForm.id > 0 ? '编辑手册' : '新增手册'"
        v-model="po.show"
        append-to-body
        :close-on-click-modal="false"
        width="50%"
        :before-close="close"
    >
        <el-form :model="po.quoteForm" ref="poFormRef" label-width="120px" :rules="rules">
            <el-form-item prop="pid" label="分类" required>
                <el-select v-model="po.quoteForm.pid" clearable>
                    <el-option v-for="item in po.configLists" :key="item.id" :label="item.cname" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item prop="c_title" label="手册标题">
                <el-input v-model="po.quoteForm.c_title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="imgUrl" label="手册封面图">
                <fileUploader
                    @uploadBack="(e, f) => uploadBack(e, f)"
                    :limits="1"
                    :needSlot="false"
                    :fileLists="po.quoteForm.imgUrl ? [{ url: requestDomain + po.quoteForm.imgUrl.url }] : []"
                />
            </el-form-item>

            <el-form-item prop="e_title" label="手册详情图">
                <div class="flex multi-imgs" style="width: 100%">
                    <fileUploader @uploadBack="(e, f) => uploadBackDetail(e, f)" />
                    <GridLayout
                        v-model:layout.sync="po.quoteForm.imgLists"
                        :is-draggable="true"
                        :is-resizable="false"
                        :col-num="12"
                        :row-height="30"
                        :vertical-compact="true"
                        :use-css-transforms="true"
                        style="width: 640px"
                    >
                        <GridItem
                            v-for="(item, index) in po.quoteForm.imgLists"
                            :key="item.i"
                            class="l-item"
                            :static="item.static"
                            :x="item.x"
                            :y="item.y"
                            :w="item.w"
                            :h="item.h"
                            :i="item.i"
                            @layout-updated="layoutUpdatedEvent"
                        >
                            <div style="position: relative">
                                <el-image
                                    style="width: 100px; height: 100px; border: 1px solid #dddddd"
                                    :src="requestDomain + item.img.url"
                                    fit="contain"
                                />
                                <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-delete" @click="handleRemove(index)">
                                        <el-icon><Delete /></el-icon>
                                    </span>
                                </span>
                            </div>
                        </GridItem>
                    </GridLayout>
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="resetForm(poFormRef)">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 认</el-button>
        </template>
    </el-dialog>
</template>
<script setup>
import request from '@/request/index.js';
import { ElMessage } from 'element-plus';
import { reactive, ref, onMounted, watch } from 'vue';
import '@wangeditor/editor/dist/css/style.css';
import fileUploader from '@/components/fileUploader.vue';
import { requestDomain } from '../../../../package.json';
import { Plus, Delete } from '@element-plus/icons-vue';
import { GridLayout, GridItem } from 'vue3-grid-layout-next';
const props = defineProps({
    visible: Boolean,
    articleId: Number
});
const emit = defineEmits(['parentCallback', 'closeDialog']);

const poFormRef = ref();

const rules = reactive({
    pid: [{ required: true, trigger: 'change', message: '请选择父菜单' }]
});

let po = reactive({
    show: false,
    quoteForm: {
        id: 0,
        imgUrl: '',
        imgLists: [],
        c_title: '',
        pid: ''
    },
    configLists: [],
    childConfigLists: [],
    layoutJSON: []
});

const uploadRef = ref();
const handleSuccess = e => {
    po.quoteForm.imgUrl = e.url;
    uploadRef.value.clearFiles();
};

const newQuoteItem = () => {
    po.quoteForm.quoteInfo.push({
        c_title: '',
        e_title: '',
        is_required: 0,
        field_name: '',
        limit_nums: 20
    });
};
const layoutUpdatedEvent = () => {
    const layout = JSON.parse(JSON.stringify(po.quoteForm.imgLists));
    layout.sort((a, b) => {
        if (a.y !== b.y) {
            return a.y - b.y;
        } else {
            return a.x - b.x;
        }
    });

    const imgLists = [];
    layout.forEach(item => {
        imgLists.push(item.img);
    });
    return imgLists;
};
const removeQuoteItem = index => {
    po.quoteForm.quoteInfo.splice(index, 1);
};
// 图片上传返回
const uploadBack = (e, isRemove) => {
    if (isRemove) {
        po.quoteForm.imgUrl = '';
    } else {
        po.quoteForm.imgUrl = e;
    }
};
const handleRemove = index => {
    po.quoteForm.imgLists.splice(index, 1);
};
const uploadBackDetail = (e, isRemove, index) => {
    if (isRemove) {
        po.quoteForm.imgLists.splice(index, 1);
    } else {
        po.quoteForm.imgLists.push({
            x: (po.quoteForm.imgLists.length * 2) % 12,
            y: po.quoteForm.imgLists.length + 12, // puts it at the bottom
            w: 2,
            h: 2,
            i: po.quoteForm.imgLists.length + 1,
            img: e
        });
    }
};
const getArticleDetail = async () => {
    const rsp = await request('fetchQuotesConfig', { id: props.articleId });
    if (rsp.status === 200) {
        const articleData = rsp.data;
        articleData.imgUrl = JSON.parse(articleData.imgUrl);
        articleData.imgLists = JSON.parse(articleData.imgLists);
        let imgLists = [];
        articleData.imgLists.forEach((item, index) => {
            imgLists.push({
                x: (index * 2) % 12,
                y: index + 12, // puts it at the bottom
                w: 2,
                h: 2,
                i: index,
                img: item
            });
        });
        articleData.imgLists = imgLists;
        po.quoteForm = articleData;
        po.show = props.visible;
    }
};

const getChildMenu = async function () {
    po.childConfigLists = [];
    po.quoteForm.cid = '';
    const result = await request('queryConfigLists', {
        pid: po.quoteForm.pid
    });
    po.childConfigLists = result.data.list;
};
// 根据应用查询角色级联信息
const queryConfigs = async function () {
    const result = await request('queryConfigLists', {
        status: 0,
        pid: 0
    });
    const list = result.data.list;
    po.configLists = list;
    if (props.articleId > 0) {
        getArticleDetail();
    } else {
        po.show = props.visible;
    }
};
queryConfigs();

const submitForm = () => {
    poFormRef.value.validate(async valid => {
        if (valid) {
            const imgLists = JSON.stringify(layoutUpdatedEvent());
            const imgUrl = JSON.stringify(po.quoteForm.imgUrl);
            const postData = {
                id: po.quoteForm.id,
                imgUrl: imgUrl,
                imgLists: imgLists,
                c_title: po.quoteForm.c_title,
                pid: po.quoteForm.pid
            };
            const requestMethod = po.quoteForm.id !== 0 ? 'updateQuotesConfig' : 'addQuotesConfig';
            const result = await request(requestMethod, postData);
            if (result.status === 200) {
                ElMessage({ message: result.msg, type: 'success' });
            }
            emit('parentCallback');
        } else {
            console.log('error submit!');
            return false;
        }
    });
};
const close = () => {
    emit('closeDialog');
};
const resetForm = poFormRef => {
    poFormRef.resetFields();
    close();
};
</script>
<style lang="scss">
.multi-imgs .el-upload-list__item {
    display: none;
}
.selected-role__list {
    width: 100%;
    margin-bottom: 8px;
    flex-wrap: wrap;
}
.mgr {
    margin-right: 8px;
}
.mgt {
    margin-top: 8px;
}
.cascader-lists {
    width: 100%;
}
</style>
